import * as React from 'react';
import { NumericFormat } from 'react-number-format';
import { Input } from '@/components/forms/ui/input';

type NumberFieldProps = {
  id: string;
  label: string;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  description?: React.ReactNode;
  placeholder?: string;
  decimalScale?: number;
  min?: number;
};

export function NumberField({
  id,
  label,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  description,
  placeholder = '0',
  decimalScale = 0,
  min
}: NumberFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-sm font-medium">
        {label}
      </label>
      {description ? <span className="text-muted-foreground text-xs">{description}</span> : null}
      <NumericFormat
        id={id}
        aria-label={label}
        aria-invalid={error ? true : undefined}
        thousandSeparator
        decimalScale={decimalScale}
        allowNegative={false}
        value={value ?? ''}
        customInput={Input}
        placeholder={placeholder}
        inputMode="numeric"
        disabled={disabled}
        min={min}
        onValueChange={(vals, sourceInfo) => {
          if (sourceInfo.source !== 'event') return;
          onChange(vals.floatValue);
        }}
        onBlur={onBlur}
      />
      {error ? <span className="text-destructive text-sm">{error}</span> : null}
    </div>
  );
}
